import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ToolOutput } from '../../../../../informate/models/calculationModels';
import { UserSettingModel } from '../../../../models/informate';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { CustomToastService } from 'src/app/services/custom-toast.service';

@Component({
    selector: 'app-calculation-preferences-calc-results',
    templateUrl: './calculation-preferences-calc-results.component.html',
    styleUrls: ['./calculation-preferences-calc-results.component.scss'],
    standalone: false
})
export class CalculationPreferencesCalcResultsComponent implements OnChanges, OnInit {
    @Input() form: UntypedFormGroup;

    @Input()
    set dataSource(value: UserSettingModel[]) {
        this._dataSource = value;
    }
    get dataSource(): UserSettingModel[] {
        return this._dataSource;
    }

    private _dataSource: UserSettingModel[];
    resultOptions: string[] = [
        'Applied Bolt Load Stress Percentage',
        'Bolt Quantity',
        'Bolt Size',
        'Bolt Load',
        'Combined Weight',
        'Extension',
        'Joint Thickness',
        'Manufacturer Allows Clamp Alignment',
        'Minimum Bolt Length',
        'Nut AF',
        'Percentage Residual Yield',
        'Residual Bolt Load',
        'Residual Bolt Stress',
        'Torque Long Form',
        'Torque Short Form',
        'Turn Of Nut',
    ];
    resultOptionsMap;
    resultOptionsChecked: string;
    selectedTool: ToolOutput;

    constructor(
        private user_utility: UserUtilityService,
        private customToastService: CustomToastService
    ) {}

    ngOnInit(): void {
        if (this.dataSource?.length !== 1) return;

        this.initialise();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.dataSource.firstChange) return;

        this.initialise();
    }

    initialise(): void {
        this.resultOptionsChecked = this.dataSource[0].value;
        const checkedOptionArray: string[] = this.resultOptionsChecked.split(',');

        this.resultOptionsMap = {};
        for (var x = 0; x < this.resultOptions.length; x++) {
            this.resultOptionsMap[this.resultOptions[x].replace(/\s+/g, '_')] = checkedOptionArray.includes(this.resultOptions[x]);
        }
    }

    setFieldValue(option, e): void {
        this.resultOptionsMap[option.replace(/\s+/g, '_')] = e.checked;

        const filtered = this.resultOptions.filter((item) => {
            return this.resultOptionsMap[item.replace(/\s+/g, '_')] === true;
        });

        this.form.get(this.setFieldKey()).setValue(filtered.join(','));
        if (this.resultOptionsChecked !== filtered.join(',')) {
            this.form.get(this.setFieldKey()).markAsDirty();
            this.form.get(this.setFieldKey()).markAsTouched();
        } else {
            this.form.get(this.setFieldKey()).markAsPristine();
        }

        this.user_utility.noneSelectedPassPct = Object.values(this.resultOptionsMap).every((value) => value === false);

        if (this.user_utility.noneSelectedPassPct) {
            this.customToastService.infoToast('Atleast one pass must be selected!', 'Info');
            this.form.setErrors({ invalidForm: true });
        }
    }

    setCheckedValue(option) {
        const checkedOptionArray: string[] = this.resultOptionsChecked.split(',');

        return checkedOptionArray.includes(option);
    }

    setFieldKey(): string {
        return this.dataSource[0].setting.key;
    }
}
